<template>
  <svg
    width="1875"
    height="1055"
    viewBox="0 0 1875 1055"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1521_20397)">
      <g clip-path="url(#clip1_1521_20397)">
        <path
          d="M551.867 963.841L549.482 961.622L551.15 960.451L553.534 962.669L551.867 963.841V963.841Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M463.542 880.672L455.445 889.807L448.348 885.696L456.446 876.561L463.542 880.672H463.542Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M609.374 870.892L622.183 871.733L621.75 876.038L608.942 875.195L609.374 870.892H609.374Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M298.269 799.018L301.913 793.055L306.139 794.743L302.493 800.706L298.269 799.018V799.018Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M358.349 643.495L363.177 650.311L373.317 646.096L376.576 651.207L363.274 656.792L354.998 644.833L358.349 643.495V643.495Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M724.404 577.948L737.588 570.203L747.506 581.237L734.324 588.983L724.404 577.948H724.404Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1038.45 669.255L1051.92 668.505L1052.31 673.126L1038.84 673.876"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1404.49 564.758L1400.16 574.97L1394.12 573.294L1398.45 563.089L1404.49 564.761V564.758V564.758Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M816.509 515.631L843.538 499.256L849.995 506.223L822.967 522.595L816.509 515.63V515.631Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1186.8 512.542L1198.33 507.801L1201.65 513.082L1190.13 517.822L1186.8 512.542V512.542Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M944.065 501.156L1012.63 459.077L1018.89 465.749L950.33 507.827L944.065 501.156V501.156Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1075.04 492.362L1047.46 457.338L1061.48 447.827L1089.24 478.601L1075.04 492.362V492.362Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1093.1 472.584L1118.82 455.146L1126.62 462.662L1100.9 480.102L1093.1 472.584V472.584Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1096.61 298.949L856.584 455.346L844.525 443.253L1084.55 286.856L1096.61 298.949H1096.61Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M945.705 439.985L966.471 427.31L974.022 435.393L953.257 448.071L945.705 439.985V439.985Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1200.77 358.542L1166.39 398.792L1157.4 393.776L1191.79 353.527L1200.77 358.542H1200.77Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1286.7 313.792L1298.48 323.528L1294.59 326.602L1282.81 316.866L1286.7 313.792Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1185.05 288.813L1251.21 246.548L1257.62 253.105L1191.46 295.368L1185.05 288.813V288.813Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1038.84 673.878L1038.45 669.256"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M987.861 421.01L985.247 418.345L1172.41 298.38L1187.59 304.581L1189.52 312.556L1195.45 309.123L1202.03 316.555L1195.68 320.23L1197.7 322.518L1191.04 326.373L1183.14 317.452L1176.68 318.354L1153.27 333.677L1163.27 343.668L1157.6 347.377L1147.84 337.622L1121.02 355.173L1130.1 364.238L1124.02 368.22L1115.44 359.655L1088.59 377.227L1096.8 385.42L1090.35 389.639L1081.69 380.985L1055.59 398.067L1064.21 406.666L1056.56 411.67L1047.44 402.569L1020.45 420.238L1029.08 428.852L1021.63 433.728L1011.39 423.508L997.444 432.639L989.711 443.592"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M989.711 443.591L976.6 437.967L973.05 426.004L987.861 421.009"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1566.15 501.864L1562.15 511.501L1556.77 510.041L1560.76 500.405L1566.15 501.864Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1527.99 453.406L1520.72 461.348L1515 457.925L1522.27 449.982L1527.99 453.406V453.406Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M608.839 818.602L595.587 824.87L572.819 832.628L565.941 835.379L558.536 840.522L553.955 846.315L551.945 850.947L551.149 859.248L552.727 865.767L556.22 870.904L569.339 884.218L572.199 885.962"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M795.808 928.642L753.758 953.341L729.009 967.832L722.392 969.067L715.217 968.523L588.073 907.793L574.109 899.285"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M565.397 893.976L560.895 891.232L546.19 876.307L541.299 869.12L539.048 859.816L540.092 848.93L543.084 842.035L549.368 834.088L559.261 827.217L567.82 823.793L583.057 818.602"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M580.912 891.271L594.763 899.71L630.073 916.575L639.919 919.126L650.375 920.139L660.853 919.18L667.387 917.831L682.976 912.472L691.419 912.5L699.255 914.723L706.262 918.839L711.882 924.951L714.764 931.61L715.271 936.119L714.868 955.241L716.182 957.705L720.621 959.826L724.136 959.169L746.985 945.792L795.808 917.115"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M572.199 885.962L573.573 886.799L579.267 890.268L580.912 891.27"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M574.109 899.285L572.523 898.319L566.892 894.887L565.396 893.977"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M656.795 929.339L702.918 951.37L703.23 936.476L702.917 933.687L701.132 929.564L697.702 925.834L693.609 923.43L689.345 922.22L685.403 922.206L671.25 927.07L663.028 928.768L656.795 929.339V929.339Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M583.057 818.602L590.2 816.168L604.692 809.313L618.209 800.064L625.483 791.324L631.793 778.597L635.137 767.453L634.548 754.437L630.997 742.738L614.663 725.153L608.434 722.741L601.533 722.982L597.253 724.826L591.974 729.058L574.475 745.73L546.765 767.148L513.814 785.893L497.679 792.744L485.499 797.217L472.347 799.562L457.89 799.777L443.122 797.071L426.079 789.311L416.588 782.372L411.387 771.73L411.096 764.824L414.426 756.071L418.401 749.976L429.284 742.044L454.33 727.256L585.547 645.797"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M585.533 645.809L611.087 629.946L664.579 592.366L674.076 586.66"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M689.74 589.622L691.577 591.615"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M685.16 595.729L683.078 593.524"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M681.391 594.442L672.161 599.989L618.74 637.52L462.729 734.322L436.866 749.592L431.53 753.48L427.989 759.305L426.858 765.852L428.15 770.283L431.193 774.72L436.43 778.279L448.665 783.987L458.946 786.502L471.208 787.075L481.507 786.224L492.398 784.017L507.538 777.589L509.091 776.706L511.964 775.071L539.115 759.627L565.72 739.062L583.15 722.457L590.048 716.928L598.29 713.377L610.913 712.934L622.503 717.421L642.076 738.495L646.506 753.088L647.2 768.44L643.262 781.564L636.159 795.891L627.243 806.604L611.656 817.269L608.839 818.602"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M674.074 586.66L675.683 585.694L681.008 582.494L682.399 581.657L684.278 580.528"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M691.628 588.507L689.684 589.56L687.981 590.481L683.02 593.463L681.392 594.442"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M795.808 522.487L787.952 528.004L752.557 553.191L724.554 570.689L691.629 588.507"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M684.278 580.528L717.05 560.834L742.438 543.658L777.725 518.55L795.808 505.85"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M795.808 917.114L880.346 867.459L895.735 856.712L909.594 845.429L921.923 833.253L931.402 821.777L933.448 818.602"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M946.455 818.602L941.345 826.536L931.205 838.812L918.169 851.683L903.61 863.538L887.52 874.775L795.808 928.643"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M990.066 676.607L982.779 634.267L978.687 600.788L978.761 587.244L979.823 572.638L985.503 554.863L995.781 537.369"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M995.781 537.369L1004.04 528.634L1009.87 524.492L1016.02 521.416L1022.49 519.933L1029.28 519.779L1035.41 520.598L1040.98 522.123L1048.3 526.309L1053.53 530.845L1070.52 549.759L1132.47 616.906L1143.38 625.089L1156.71 631.513L1169.83 635.275L1179.9 636.728L1193.47 637.129L1204.21 635.929L1218.03 633.144L1237.77 626.84L1254.89 619.817L1265.88 612.949L1276.23 603.778L1283.5 594.775L1288.59 585.408L1293.26 572.853L1296.18 559.229L1296.9 547.015L1296.74 536.035L1293.54 520.619L1288.14 506.08L1281.42 493.838L1246.45 439.889L1239.73 426.231L1237.37 415.952L1237.64 406.924L1239.64 402.15L1245.15 395.441L1265.18 377.273L1325.29 320.117L1345.46 299.199"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1005.9 549.623L998.184 558.979L992.642 574.267L991.674 587.57L991.604 600.295L995.605 633.033L1003.04 676.197"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1354.36 306.636L1335.13 326.59L1276.2 382.377L1255.01 401.592L1250.89 406.613L1250.02 408.693L1249.82 415.151L1251.72 423.434L1257.75 435.691L1292.61 489.467L1299.82 502.585L1305.66 518.334L1309.15 535.14L1309.33 547.193L1308.55 560.331L1305.37 575.164L1300.27 588.885L1294.46 599.572L1286.08 609.949L1274.33 620.361L1261.56 628.342L1242.87 636.009L1221.83 642.729L1206.57 645.804L1194.1 647.2L1178.57 646.741L1166.64 645.018L1151.4 640.646L1135.89 633.175L1123.19 623.647L1061.84 556.73L1044.19 537.066L1039.93 534.601L1035.67 533.348L1031.94 533.246L1027.89 533.94L1023.17 535.961L1018.99 538.778L1014.7 541.775L1010.09 545.476L1005.9 549.624"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M991.464 684.729L990.936 681.658L990.616 679.795L990.066 676.607"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1003.04 676.198L1003.52 679.03L1003.85 680.955L1004.36 683.891"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1345.46 299.198L1347.47 297.114L1353.3 291.067L1354.79 289.517"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1364.29 296.34L1362.36 298.345L1356.36 304.559L1354.36 306.636"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M926.04 438.263L891.023 466.355L891.839 467.685L895.452 467.964L901.865 466.792L907.049 464.711L934.529 437.324L940.113 431.917L1057.55 356.751L1188.43 272.004L1246.45 234.316L1256.57 226.914L1255.75 226.068L1249.76 229.95L1180.82 274.349L1126.42 309.21L1056.54 354.171L979.62 403.676L926.04 438.263V438.263Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M933.448 818.602L949.954 792.98L982.548 738.913L988.862 725.655L992.212 713.714L993.251 703.626L992.34 689.81L991.464 684.729"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1004.36 683.891L1005.21 688.813L1006.19 703.781L1005.01 715.311L1001.25 728.702L994.404 743.084L961.928 794.589L946.456 818.602"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M795.808 505.849L809.714 496.085L839.377 478.127L969.936 393.856L1052.03 341.024L1116.65 299.285L1171.05 264.417L1239.96 220.039L1271.04 199.919"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1298.05 199.919L1286.1 207.613L1262.25 227.306L1249.16 236.881L1191.03 274.634L1058.94 360.26L943.106 434.399L937.822 439.517L902.59 474.628L898.415 476.916L892.93 478.667L856.53 485.978L848.884 488.065L819.476 505.866L795.808 522.488"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1354.79 289.517L1370.89 272.822L1385.87 256.586L1411.77 225.691L1422.67 215.274"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1422.67 231.121L1421.87 231.884L1397.56 261.063L1380.97 279.04L1364.29 296.34"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1271.04 199.918L1290.16 187.538"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1300.39 198.414L1298.05 199.92"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1300.45 180.874L1320.75 167.735L1379.12 127.836L1406.68 108.935L1418.54 101.375L1422.67 99.0303"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1422.67 111.773L1415.33 116.455L1389.79 139.028L1331.97 177.956L1310.46 191.907"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1290.16 187.539L1292 186.347L1299.22 181.67L1300.45 180.874"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1310.46 191.907L1309.35 192.625L1304.27 195.918L1302.36 197.147L1300.39 198.414"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1422.67 215.275L1430.6 207.698L1435.89 201.076L1436.54 199.919"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1448.65 203.111L1447.03 205.999L1440.79 213.802L1422.67 231.121"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1450.45 199.919L1450.23 200.318L1448.64 202.96"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1436.54 199.92L1438.88 195.774L1441.54 190.208L1453.76 117.742L1452.15 112.514L1449.1 108.961L1444.08 106.465L1439.7 105.564L1435.54 105.55L1431.37 106.595L1426.1 109.588L1422.68 111.77L1422.67 111.774"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1422.67 99.0299L1422.68 99.0258L1425.72 97.2997L1433.64 95.3096L1441.32 95.3363L1449.07 96.9305L1457.99 101.367L1463.87 108.219L1466.63 117.174L1453.88 192.775L1450.55 199.739L1450.45 199.919"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1264.21 393.249L1276.2 382.377L1335.13 326.589L1354.36 306.635L1356.36 304.558L1362.36 298.345L1364.29 296.34L1380.97 279.04L1397.56 261.062L1421.87 231.884L1422.67 231.121L1440.79 213.803L1447.03 205.999L1448.65 203.111L1448.64 202.96L1450.23 200.317L1450.45 199.918L1450.55 199.739L1453.88 192.775L1466.63 117.174L1463.87 108.219L1457.99 101.367L1449.07 96.9305L1441.32 95.3363L1433.64 95.3096L1425.72 97.2997L1422.68 99.0258L1422.67 99.03L1418.54 101.375L1406.68 108.935L1379.12 127.836L1320.75 167.735L1300.45 180.874L1299.22 181.67L1292 186.347L1290.16 187.539L1271.04 199.918L1239.96 220.039L1171.05 264.416L1116.65 299.285L1052.03 341.023L969.936 393.855L839.377 478.126L819.706 490.035"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M741.045 960.784L753.758 953.341L795.808 928.642L887.52 874.776L903.611 863.539L918.169 851.683L931.205 838.813L941.346 826.536L946.456 818.602L961.927 794.589L994.403 743.084L1001.25 728.702L1005.01 715.311L1006.19 703.781L1005.21 688.813L1004.36 683.891L1003.85 680.955L1003.52 679.029L1003.04 676.198H1003.04L995.605 633.034L991.605 600.296L991.674 587.571L992.643 574.268L998.184 558.98L1005.9 549.624L1010.09 545.476L1014.7 541.775L1018.99 538.778L1023.17 535.961L1027.89 533.94L1031.94 533.247L1035.67 533.348L1039.93 534.602L1044.19 537.066L1061.84 556.73L1123.19 623.647L1135.89 633.175L1151.4 640.646L1166.64 645.018L1178.57 646.741L1194.1 647.2L1206.57 645.804L1221.83 642.729L1242.87 636.009L1261.56 628.342L1274.33 620.361L1286.08 609.949L1294.46 599.572L1300.27 588.885L1305.37 575.165L1308.55 560.331L1309.33 547.194L1309.15 535.14L1305.66 518.335L1299.82 502.585L1292.61 489.467L1257.75 435.691L1251.72 423.435L1249.82 415.151L1250.02 408.694L1250.89 406.613L1255.01 401.592L1264.21 393.249"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M926.04 438.263L979.62 403.676L1056.54 354.171L1126.42 309.21L1180.82 274.349L1249.76 229.95L1255.75 226.068L1256.57 226.914L1246.45 234.316L1188.43 272.004L1057.55 356.751L940.113 431.917L934.529 437.324L907.049 464.711L901.865 466.792L895.452 467.964L891.839 467.685L891.023 466.355L926.04 438.263V438.263Z"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M826.899 501.372L848.884 488.064L856.53 485.977L892.93 478.666L898.415 476.915L902.59 474.627L937.822 439.516L943.106 434.399L1058.94 360.259L1191.03 274.633L1249.16 236.88L1262.25 227.305L1286.1 207.612L1298.05 199.918L1300.39 198.413L1302.36 197.146L1304.27 195.917L1309.35 192.624L1310.46 191.906L1331.97 177.955L1389.79 139.027L1415.33 116.454L1422.67 111.772L1422.68 111.768L1426.1 109.586L1431.37 106.593L1435.54 105.548L1439.7 105.562L1444.08 106.463L1449.1 108.959L1452.15 112.512L1453.76 117.74L1441.54 190.207L1438.88 195.773L1436.54 199.918L1435.89 201.075L1430.6 207.697L1422.67 215.274L1411.77 225.691L1385.87 256.586L1370.89 272.822L1354.79 289.516L1353.3 291.067L1347.47 297.113L1345.46 299.198L1325.29 320.117L1265.18 377.273L1256.88 384.797"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M735.932 952.263L724.136 959.17L720.621 959.826L716.182 957.706L714.868 955.241L715.271 936.119L714.764 931.61L711.882 924.951L706.262 918.839L699.255 914.723L691.419 912.5L682.976 912.472L667.387 917.831L660.853 919.18L650.375 920.14L639.919 919.127L630.073 916.575L594.763 899.71L580.912 891.271L579.267 890.269L573.573 886.8L572.199 885.962L569.339 884.218L556.221 870.904L552.727 865.768L551.149 859.248L551.945 850.948L553.955 846.316L558.536 840.523L565.941 835.379L572.819 832.629L595.587 824.87L608.839 818.602L611.656 817.27L627.243 806.605L636.159 795.891L643.262 781.564L647.2 768.44L646.506 753.089L642.076 738.495L622.504 717.421L610.913 712.934L598.29 713.378L590.048 716.929L583.15 722.457L565.72 739.062L539.115 759.627L511.964 775.071L509.091 776.706L507.538 777.589L492.398 784.017L481.507 786.224L471.208 787.075L458.946 786.502L448.665 783.988L436.43 778.279L431.193 774.72L428.15 770.283L426.858 765.852L427.989 759.305L431.53 753.48L436.866 749.592L462.729 734.322L618.74 637.52L672.161 599.989L681.391 594.443L683.02 593.464L687.981 590.482L689.684 589.56L691.629 588.508L724.554 570.689L752.557 553.191L787.952 528.004L795.807 522.488L819.476 505.866L826.899 501.373"
          stroke="#64E3FF"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1256.88 384.797L1245.15 395.441L1239.64 402.15L1237.64 406.925L1237.37 415.952L1239.73 426.231L1246.44 439.889L1281.42 493.839L1288.14 506.08L1293.54 520.619L1296.74 536.035L1296.9 547.015L1296.18 559.229L1293.26 572.853L1288.59 585.408L1283.5 594.775L1276.23 603.778L1265.88 612.95L1254.89 619.817L1237.77 626.84L1218.02 633.144L1204.21 635.929L1193.47 637.129L1179.89 636.728L1169.83 635.275L1156.7 631.513L1143.38 625.09L1132.47 616.907L1070.52 549.76L1053.53 530.845L1048.3 526.309L1040.98 522.123L1035.41 520.598L1029.28 519.78L1022.49 519.933L1016.02 521.416L1009.87 524.492L1004.04 528.634L995.781 537.369L985.503 554.864L979.823 572.638L978.76 587.244L978.686 600.788L982.779 634.267L990.066 676.608L990.615 679.796L990.935 681.658L991.464 684.729L992.34 689.81L993.251 703.626L992.212 713.714L988.862 725.655L982.548 738.913L949.954 792.98L933.448 818.602L931.401 821.777L921.923 833.254L909.594 845.43L895.734 856.713L880.345 867.459L795.807 917.115L746.985 945.792L735.931 952.263"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M819.706 490.035L809.715 496.084L795.808 505.849V505.85L777.725 518.55L742.438 543.659L717.05 560.835L684.278 580.529L682.399 581.657L681.008 582.494L675.683 585.694L674.074 586.661H674.076L664.578 592.366L611.087 629.946L585.533 645.809L585.547 645.797L454.33 727.256L429.284 742.044L418.401 749.976L414.426 756.071L411.096 764.823L411.387 771.73L416.588 782.372L426.079 789.31L443.122 797.071L457.89 799.777L472.347 799.562L485.499 797.217L497.679 792.744L513.814 785.893L546.765 767.148L574.475 745.73L591.974 729.058L597.253 724.826L601.533 722.982L608.434 722.741L614.663 725.153L630.997 742.738L634.548 754.437L635.137 767.453L631.793 778.597L625.483 791.324L618.209 800.063L604.692 809.313L590.2 816.168L583.057 818.602L567.82 823.794L559.26 827.217L549.368 834.088L543.083 842.035L540.092 848.93L539.047 859.816L541.299 869.12L546.189 876.308L560.894 891.232L565.397 893.976L566.893 894.887L572.523 898.319L574.11 899.285L588.073 907.792L632.308 928.921L633.141 929.046L641.858 929.847L656.795 929.339L663.029 928.768L671.251 927.07L685.404 922.206L689.345 922.22L693.609 923.43L697.703 925.834L701.133 929.564L702.917 933.687L703.231 936.477L702.918 951.37L705.053 960.449L708.054 964.53L709.325 965.708L715.67 968.739L722.392 969.066L729.009 967.831L741.045 960.785"
          stroke="#64E3FF"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1463.72 107.91L1457.84 101.057L1448.92 96.621L1441.17 95.0268L1433.49 95L1425.57 96.9901L1422.53 98.7162L1422.52 98.7204L1418.38 101.065L1406.53 108.626L1378.97 127.526L1320.59 167.425L1300.3 180.564L1299.07 181.36L1291.85 186.037L1290 187.229L1270.88 199.609L1239.81 219.729L1170.9 264.107L1116.5 298.975L1051.88 340.714L969.783 393.546L839.224 477.817L809.561 495.774L795.654 505.539L777.571 518.24L742.285 543.349L716.896 560.525L684.125 580.219L682.246 581.347L680.854 582.184L675.53 585.385L673.921 586.351L664.425 592.057L610.933 629.636L585.38 645.499L585.393 645.487L454.177 726.947L429.131 741.735L418.247 749.666L414.273 755.761L410.942 764.514L411.234 771.42L416.435 782.063L425.926 789.001L442.969 796.761L457.737 799.468L472.193 799.252L485.346 796.908L497.526 792.434L513.66 785.584L546.612 766.838L574.321 745.42L591.821 728.749L597.099 724.517L601.38 722.672L608.28 722.431L614.51 724.844L630.844 742.428L634.395 754.127L634.984 767.143L631.639 778.287L625.33 791.015L618.056 799.754L604.538 809.003L590.047 815.858L582.904 818.292L567.667 823.484L559.107 826.907L549.214 833.779L542.93 841.725L539.938 848.62L538.894 859.507L541.145 868.811L546.036 875.998L560.741 890.922L565.243 893.667L566.739 894.577L572.37 898.009L573.956 898.975L587.92 907.483L632.155 928.611L632.988 928.737L641.705 929.537L656.642 929.029L662.875 928.458L671.097 926.76L685.25 921.897L689.192 921.91L693.456 923.12L697.55 925.524L700.979 929.255L702.764 933.378L703.077 936.167L702.765 951.06L704.899 960.139L707.9 964.22L709.172 965.398L715.064 968.213L722.239 968.756L728.856 967.522L753.605 953.031L795.654 928.332L887.367 874.466L903.457 863.229L918.015 851.373L931.051 838.502L941.192 826.226L946.302 818.292L961.774 794.279L994.25 742.774L1001.1 728.392L1004.85 715.001L1006.04 703.471L1005.05 688.503L1004.21 683.581L1003.7 680.645L1003.37 678.719L1002.88 675.888H1002.88L995.452 632.724L991.451 599.986L991.52 587.261L992.489 573.958L998.031 558.67L1005.75 549.314L1009.93 545.166L1014.55 541.465L1018.84 538.468L1023.02 535.651L1027.74 533.63L1031.79 532.937L1035.51 533.038L1039.78 534.292L1044.04 536.756L1061.69 556.42L1123.04 623.337L1135.74 632.865L1151.24 640.336L1166.48 644.708L1178.41 646.431L1193.95 646.89L1206.42 645.494L1221.67 642.419L1242.72 635.699L1261.41 628.032L1274.18 620.051L1285.93 609.639L1294.31 599.262L1300.12 588.575L1305.22 574.855L1308.4 560.021L1309.18 546.884L1309 534.83L1305.51 518.025L1299.66 502.275L1292.46 489.157L1257.6 435.381L1251.57 423.125L1249.67 414.841L1249.86 408.384L1250.73 406.303L1254.86 401.282L1276.04 382.067L1334.97 326.28L1354.21 306.326L1356.21 304.249L1362.2 298.035L1364.14 296.03L1380.82 278.73L1397.41 260.753L1421.72 231.574L1422.52 230.811L1440.64 213.493L1446.87 205.689L1448.5 202.802L1448.48 202.65L1450.08 200.007L1450.3 199.609L1450.4 199.429L1453.72 192.465L1466.48 116.864L1463.72 107.91ZM925.888 437.952L979.467 403.366L1056.39 353.861L1126.27 308.9L1180.66 274.039L1249.6 229.64L1255.6 225.758L1256.42 226.604L1246.3 234.006L1188.27 271.694L1057.4 356.441L939.96 431.607L934.376 437.013L906.896 464.401L901.712 466.482L895.299 467.653L891.686 467.375L890.871 466.045L925.888 437.952ZM1441.38 189.898L1438.72 195.464L1436.39 199.609L1435.74 200.766L1430.45 207.388L1422.52 214.965L1411.62 225.382L1385.71 256.277L1370.73 272.513L1354.64 289.207L1353.14 290.758L1347.31 296.804L1345.3 298.888L1325.13 319.807L1265.03 376.963L1245 395.131L1239.48 401.84L1237.49 406.615L1237.22 415.643L1239.57 425.921L1246.29 439.58L1281.26 493.529L1287.99 505.771L1293.39 520.31L1296.59 535.726L1296.75 546.705L1296.02 558.92L1293.1 572.544L1288.44 585.099L1283.35 594.466L1276.07 603.468L1265.73 612.64L1254.74 619.507L1237.62 626.53L1217.87 632.834L1204.06 635.62L1193.32 636.82L1179.74 636.418L1169.67 634.966L1156.55 631.203L1143.22 624.78L1132.32 616.597L1070.36 549.45L1053.38 530.535L1048.15 526L1040.83 521.813L1035.25 520.289L1029.12 519.47L1022.33 519.624L1015.87 521.106L1009.72 524.183L1003.89 528.324L995.628 537.06L985.35 554.554L979.67 572.328L978.607 586.934L978.533 600.479L982.626 633.957L989.913 676.298L990.463 679.486L990.783 681.349L991.311 684.419L992.187 689.501L993.098 703.317L992.059 713.404L988.709 725.345L982.395 738.604L949.801 792.67L933.295 818.292L931.248 821.468L921.77 832.944L909.441 845.12L895.582 856.403L880.193 867.15L795.654 916.805L746.832 945.482L723.983 958.859L720.468 959.516L716.029 957.395L714.715 954.931L715.118 935.809L714.611 931.299L711.729 924.641L706.109 918.529L699.102 914.413L691.266 912.19L682.823 912.162L667.233 917.521L660.7 918.87L650.222 919.829L639.766 918.816L629.92 916.265L594.609 899.4L580.759 890.96L579.114 889.958L573.42 886.489L572.046 885.652L569.186 883.908L556.067 870.594L552.574 865.458L550.996 858.938L551.792 850.638L553.802 846.005L558.383 840.213L565.788 835.069L572.666 832.318L595.434 824.56L608.686 818.292L611.503 816.959L627.09 806.294L636.006 795.581L643.109 781.254L647.047 768.13L646.353 752.779L641.923 738.185L622.35 717.111L610.76 712.624L598.137 713.067L589.895 716.618L582.997 722.147L565.567 738.752L538.962 759.317L511.811 774.761L508.938 776.396L507.385 777.279L492.245 783.707L481.354 785.914L471.055 786.765L458.793 786.192L448.512 783.678L436.276 777.969L431.04 774.41L427.997 769.973L426.705 765.542L427.836 758.995L431.377 753.17L436.713 749.282L462.576 734.012L618.587 637.21L672.008 599.679L681.238 594.132L682.867 593.154L687.828 590.172L689.531 589.25L691.476 588.197L724.401 570.379L752.404 552.881L787.799 527.694L795.654 522.177L819.323 505.556L848.731 487.755L856.377 485.668L892.777 478.357L898.262 476.605L902.437 474.318L937.668 439.207L942.953 434.089L1058.78 359.949L1190.88 274.323L1249.01 236.57L1262.1 226.995L1285.95 207.303L1297.9 199.608L1300.24 198.103L1302.21 196.837L1304.12 195.608L1309.2 192.315L1310.3 191.597L1331.82 177.646L1389.64 138.718L1415.17 116.144L1422.52 111.463L1422.52 111.459L1425.95 109.277L1431.22 106.284L1435.39 105.239L1439.55 105.253L1443.92 106.154L1448.95 108.65L1452 112.203L1453.61 117.431L1441.38 189.898Z"
          fill="white"
          fill-opacity="0.2"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1521_20397">
        <rect width="1269" height="875" fill="white" transform="translate(298 95)" />
      </clipPath>
      <clipPath id="clip1_1521_20397">
        <rect width="1268.44" height="874.377" fill="white" transform="translate(298 95)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * レース動画再生画面: GPS詳細 サーキットマップ: Fuji
 */
export default defineComponent({
  name: 'CircuitMapImageFuji',
})
</script>
